module.exports = __webpack_public_path__ + "img/noticia-29B.92d08839.jpg";